import { render, staticRenderFns } from "./claim-upload.vue?vue&type=template&id=329dde56&scoped=true&"
import script from "./claim-upload.vue?vue&type=script&lang=js&"
export * from "./claim-upload.vue?vue&type=script&lang=js&"
import style0 from "./claim-upload.vue?vue&type=style&index=0&id=329dde56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329dde56",
  null
  
)

export default component.exports